import { render, staticRenderFns } from "./HomeWalletFeatures.vue?vue&type=template&id=220b4fbd&scoped=true"
import script from "./HomeWalletFeatures.vue?vue&type=script&lang=js"
export * from "./HomeWalletFeatures.vue?vue&type=script&lang=js"
import style0 from "./HomeWalletFeatures.vue?vue&type=style&index=0&id=220b4fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b4fbd",
  null
  
)

export default component.exports